import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { computed, ref, watchEffect } from "vue";
import SessionSlide from "../../sessions/session-slide.vue";
import { CmsControlSlide } from "../../../services/cms/cms-type-definitions";
import TeamEffectivenessQuestionnaire from "../../team-effectiveness/team-effectiveness-questionnaire.vue";
import {
  TeamEffectivenessQuestionnaireCreationApiModel,
  TeamEffectivenessRatingsApiModel,
} from "../../../api-models";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import pinia from "../../../stores";
import SlideText from "./slide-text.vue";
import { useToggle } from "../../../composables/useToggle";


export default /*#__PURE__*/_defineComponent({
  __name: 'control-slide',
  props: {
    slice: {},
    index: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

// const visual = ref<CmsImg | null>(null);
const slide = ref<SessionSlide | null>(null);
const isSubmitting = ref(false);

const prismicSlice = computed<CmsControlSlide>(() => {
  return props.slice.prismicSlice as CmsControlSlide;
});

const controlType = computed(() => prismicSlice.value.primary.control.type);
const visualDiv = computed(() => slide?.value?.visualDiv);

// TODO: to handle properly => get reviewId
const submitQuestionnaire = (rawRatings: TeamEffectivenessRatingsApiModel): void => {
  isSubmitting.value = true;
  // get reviewId
  const request = {
    reviewId: "",
    rawRatings,
  } as TeamEffectivenessQuestionnaireCreationApiModel;
  // POST questionnaire => isSubmitting = false;
};

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

__expose({
  slide,
  visualDiv,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SessionSlide, {
    ref_key: "slide",
    ref: slide,
    id: 'slide' + props.index,
    "visual-position": "fixed",
    class: _normalizeClass({
      'slide-after-activity': !_unref(isDisplayed),
      'submitted-mapping': _unref(isDisplayed),
    }),
    "data-test": `session-slide-${_ctx.index}`
  }, {
    text: _withCtx(() => [
      _createVNode(SlideText, {
        text: prismicSlice.value.primary.text_body
      }, null, 8, ["text"])
    ]),
    visual: _withCtx(() => [
      (controlType.value === 'cms-team-effectiveness-review')
        ? (_openBlock(), _createBlock(TeamEffectivenessQuestionnaire, {
            key: 0,
            "is-submitting": isSubmitting.value,
            onSubmit: submitQuestionnaire,
            class: "team-effectiveness-questionnaire-in-session"
          }, null, 8, ["is-submitting"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["id", "class", "data-test"]))
}
}

})